module.exports = __webpack_public_path__ + "img/905-d7c281.png";